import React from 'react';

const TitleBarSpacer = ({width=1}) => {
    return (
        <div className={"px-"+width}>
        </div>
    );
};

export default TitleBarSpacer;